import * as _ from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  importStudents: {
    Data: [],
    Errors: [],
  },
  importStudentsConfiguraton: {
    Data: [],
    Errors: [],
  },
  importStudentsErrors: undefined,
  ready: false,
  columnMapping: [],
  storedLanguageMappingData: [],
  storedLanguageMappingError: [],
  storedMealMappingData: [],
  storedMealMappingError: [],
  newLanguageMappingData: [],
  newMealMappingData: [],
  newSiteMappingData: [],
  gradeMappingData: [],
  importSchedule: {
    Hour: 0,
    Minute: 0,
    AMorPM: 'AM',
    DaysOfTheWeek: [0],
  },
  grades: [],
  importSettingsData: [],
  settingsDeleted: false,
  settingsError:'',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.IMPORT_STUDENT_READY:
      return {
        ...state,
        ready: action.payload,
      };
    case types.IMPORTSTUDENT_IMPORT:
      return { ...state, importStudents: action.payload.data };
    case types.IMPORTSTUDENT_ERROR:
      return {
        ...state,
        importStudents: action.payload ? action.payload.data : { Errors: [] },
      };
    case types.IMPORTSTUDENT_CLEAR_ERROR:
      return { ...state, importStudents: { Errors: undefined } };
    case types.IMPORTSTUDENT_CLEAR_DATA:
      return { ...state, importStudents: { Data: [] } };
    case types.IMPORTSTUDENT_GET_CONFIG:
      return { ...state, importStudentsConfiguraton: action.payload.data };
    case types.IMPORTSTUDENT_HEADER:
      return { ...state, importStudentHeader: action.payload.data };
    case types.IMPORTSTUDENT_HEADER_ERROR:
      return { ...state, importStudentHeader: { Data: [] } };
    case types.GET_LANGUAGES:
      return { ...state, languages: action.payload.data };
    case types.GET_LANGUAGES_ERROR:
      return { ...state, languages: action.payload.data };
    case types.GET_LANGUAGE_MAPPING_DATA:
      const { Data = [], Errors = [] } = action.payload;
      let updatedState = {};

      if (Data.length) updatedState.storedLanguageMappingData = Data;

      if (Errors.length) updatedState.storedLanguageMappingError = Errors;

      return {
        ...state,
        ...updatedState,
      };

    case types.CLEAR_CUSTOM_MAPPING_DATA:
      return {
        ...state,
        storedLanguageMappingData: [],
        storedLanguageMappingError: [],
      };
    case types.GET_MEAL_MAPPING_DATA:
      return { ...state, storedMealMappingData: action.payload.Data };
    case types.CLEAR_MAPPING_DATA:
      return { ...state, mappingData: { Data: [] } };
    case types.GET_MAPPING_DATA_ERROR:
      return { ...state, mappingData: action.payload.data };
    case types.ADD_LANGUAGE_MAPPING_DATA:
      return { ...state, newLanguageMappingData: action.payload };
    case types.ADD_MEAL_MAPPING_DATA:
      return { ...state, newMealMappingData: action.payload };
    case types.SET_SITE_MAPPING_DATA:
      return { ...state, newSiteMappingData: action.payload };
    case types.SET_GRADES:
      return { ...state, grades: action.payload.data.Data };
    case types.SET_GRADE_MAPPING_DATA:
      return { ...state, gradeMappingData: action.payload };
    case types.ADD_COLUMN_MAPPING:
      return { ...state, columnMapping: action.payload };
    case types.REMOVE_COLUMN_MAPPING:
      return {
        ...state,
        columnMapping: _.filter(state.columnMapping, (column) => {
          return column.id !== action.payload;
        }),
      };
    case types.POST_IMPORTSTUDENTS:
      return { ...state, importResponse: action.payload.data };
    case types.POST_IMPORTSTUDENTS_CLEAR_DATA:
      return { ...state, importResponse: { Data: '' } };
    case types.IMPORT_STUDENT:
      return { ...state, finalImportResponse: action.payload.data };
    case types.IMPORT_STUDENT_ERROR:
      return { ...state, finalImportResponse: action.payload.data };
    case types.POST_IMPORTSTUDENTS_ERROR:
      return { ...state, importResponse: action.payload.data };
    case types.CLEAR_ADDED_MAPPING_DATA:
      return { ...state, newLanguageMappingData: [], newMealMappingData: [] };
    case types.GET_IMPORT_SCHEDULE:
      return {
        ...state,
        importSchedule: action.payload.data,
      };
    case types.GET_IMPORT_SCHEDULE_ERROR:
      return {
        ...state,
        importSchedule: action.payload.data,
      };
    case types.POST_IMPORT_SCHEDULE:
      return { ...state, importSchedule: { Data: action.payload.data } };
    case types.GET_IMPORTSTUDENT_SETTINGS:
      return {
        ...state,
        importSettingsData: action.payload.data.Data,
      };
    case types.REMOVE_IMPORTSTUDENT_SETTINGS:
        return { ...state, settingsDeleted: action.payload };
    case types.IMPORTSTUDENT_SETTINGS_ERROR:
        return { ...state, settingsError: action.payload };
        
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/importstudents/state/reducer.js